import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { FormGroupSearchProps } from 'Components/Common/Form/form';
import MessageError from 'Components/Common/MessageError';
import SelectOptionComponent from 'Components/Common/Select/CustomSelect/SelectOptionComponent';

export default function FormSelectOption(props: FormGroupSearchProps): JSX.Element {
  const {
    onSearch,
    onSelect,
    placeholder,
    colMd,
    colLg,
    rowClass,
    colClass,
    showIcon = false,
    onEnter,
    onInputChange,
    defaultValue,
    errorMessage,
    inputSearchString = '',
    disabled,
    onLoadMore,
    onMenuClose,
    isLoading,
    options,
    onMenuFocus,
    showIconClear = false,
  } = props;
  return (
    <Form.Group as={Row} className={rowClass}>
      <Col md={colMd} lg={colLg} className={colClass}>
        <SelectOptionComponent
          onInputChange={onInputChange}
          defaultValue={defaultValue}
          onEnter={onEnter}
          placeholder={placeholder}
          onSearch={onSearch}
          onSelect={onSelect}
          showIcon={showIcon}
          inputSearchString={inputSearchString}
          disabled={disabled}
          onLoadMore={onLoadMore}
          onMenuClose={onMenuClose}
          isLoading={isLoading}
          options={options}
          onMenuFocus={onMenuFocus}
          showIconClear={showIconClear}
        />
        <MessageError message={errorMessage} />
      </Col>
    </Form.Group>
  );
}
